import request from "./../utils/request";
import store from "../store";

const syncAutomations = async () => {
    const store = require("../store").default;
    store.dispatch("automation/syncAutomations");
};
export const AUTOMATION_API = {
    listAutomations: async (filters, cursor, sort) => {
        return request
            .post(
                "/automation/list",
                { filters, cursor, sort },
                {
                    timeout: 60 * 1000 * 5,
                }
            )
            .then((response) => response.data);
    },
    findAutomationById: async (id) => {
        return request
            .get(`/automation/${id}`, {
                timeout: 60 * 1000 * 5,
            })
            .then((response) => response.data);
    },
    createAutomation: async (name, options, diagram, reference, targetContactFilter) => {
        return request
            .put(
                "/automation",
                { name, options, diagram, reference, targetContactFilter },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data)
            .finally(() => {
                syncAutomations();
            });
    },
    createEmptyTimerAutomation: async () => {
        return request
            .put(
                "/automation/empty-timer-automation",
                {},
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data)
            .finally(() => {
                syncAutomations();
            });
    },
    createEmptyEventAutomation: async (name, event, payload, reference, eventOptions) => {
        return request
            .put(
                "/automation/empty-event-automation",
                {
                    name,
                    event,
                    payload,
                    reference,
                    eventOptions,
                },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data)
            .finally(() => {
                syncAutomations();
            });
    },
    createWebhookAutomation: async (name, payload) => {
        return request
            .put(
                "/automation/webhook-automation",
                {
                    name,
                    payload,
                },
                {
                    timeout: 60 * 1000,
                    headers: store.state.app.debugMode
                        ? {
                              "x-debug-mode": store.state.app.debugMode,
                          }
                        : {},
                }
            )
            .then((response) => response.data)
            .finally(() => {
                syncAutomations();
            });
    },
    updateAutomationSingleKey: async (automationId, key, value) => {
        return request
            .post(
                `/automation/${automationId}/single-key`,
                { key, value },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    deleteMultiAutomations: async (ids) => {
        return request
            .post(
                `/automation/multi-delete`,
                { ids },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    listDeletedAutomations: async () => {
        return request
            .get(`/automation/list-deleted`, {
                timeout: 60 * 1000,
            })
            .then((response) => response.data);
    },
    restoreAutomation: async (id) => {
        return request
            .put(`/automation/${id}/restore-deleted`, {}, {
                timeout: 60 * 1000,
            })
            .then((response) => response.data);
    },
    duplicateAutomation: (automationId) => {
        return request.post(`/automation/${automationId}/duplicate`).then((response) => response.data);
    },

    exportAutomationAsJSON: (automationId) => {
        return request.get(`/automation/${automationId}/export`).then((response) => response.data);
    },

    importAutomationFromJSON: (importData) => {
        return request.post(`/automation/import`, { importData }).then((response) => response.data);
    },
    updateBillableStatus: async (automationId, billable, password) => {
        return request
            .post(
                `/automation/${automationId}/billable`,
                { billable, password },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    getActivityLogs: async (automationId) => {
        return request
            .get(`/automation/${automationId}/activity-logs`, {
                timeout: 60 * 1000,
            })
            .then((response) => response.data);
    },
    getPermissionConfig: async (automationId) => {
        return request
            .get(`/automation/${automationId}/permission-config`, {
                timeout: 60 * 1000,
            })
            .then((response) => response.data);
    },
    updatePermissionConfig: async (automationId, permissionConfig) => {
        return request
            .post(
                `/automation/${automationId}/permission-config`,
                { permissionConfig },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    DESIGN: {
        addBlock: async (id, blockId, type) => {
            return request
                .put(
                    `/automation/design/${id}/b/${blockId}`,
                    { type },
                    {
                        timeout: 60 * 1000,
                        headers: {
                            "x-debug-mode": store.state.app.debugMode,
                        },
                    }
                )
                .then((response) => response.data);
        },
        deleteSingleBlock: async (id, blockId) => {
            return request
                .delete(`/automation/design/${id}/single/${blockId}`, {
                    timeout: 60 * 1000,
                })
                .then((response) => response.data);
        },
        deleteWithChildren: async (id, blockId) => {
            return request
                .delete(`/automation/design/${id}/recursive/${blockId}`, {
                    timeout: 60 * 1000,
                })
                .then((response) => response.data);
        },
        updateBlock: async (id, blockId, payload) => {
            return request
                .post(
                    `/automation/design/${id}/b/${blockId}`,
                    { payload },
                    {
                        timeout: 60 * 1000,
                        headers: store.state.app.debugMode
                            ? {
                                  "x-debug-mode": store.state.app.debugMode,
                              }
                            : {},
                    }
                )
                .then((response) => response.data);
        },
        copyBlock: async (id, blockId, targetBlockId) => {
            return request
                .post(
                    `/automation/design/${id}/b/${blockId}/copy`,
                    { targetBlockId },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        moveBlock: async (id, blockId, targetBlockId) => {
            return request
                .post(
                    `/automation/design/${id}/b/${blockId}/move`,
                    { targetBlockId },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
    },
    PLAN: {
        list: async (filters, cursor, sort) => {
            return request
                .post(
                    `/automation/plans/history`,
                    {
                        filters,
                        cursor,
                        sort,
                    },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        cancelPlans: async (automationId, planIds) => {
            return request
                .post(
                    `/automation/plans/cancel-plans`,
                    { automationId, planIds },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        getDetailById: async (planId) => {
            return request
                .get(`/automation/plans/${planId}/detail`, {
                    timeout: 60 * 1000,
                })
                .then((response) => response.data);
        },
    },
    INSIGHTS: {
        getAutomationInsights: async (filters, timeRange) => {
            return request
                .post(
                    "/automation/insights/summary",
                    { filters, timeRange },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        getStatusDistribution: async (filters) => {
            return request
                .post(
                    "/automation/insights/status-distribution",
                    { filters },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        getDurationStatistics: async (filters) => {
            return request
                .post(
                    "/automation/insights/duration-statistics",
                    { filters },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        getTerminateReasons: async (filters) => {
            return request
                .post(
                    "/automation/insights/terminate-reasons",
                    { filters },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
    },
};
